<template> 
    <b-modal v-model="modalShow" id="modalSlider" centered hide-footer hide-header>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <button
                     type="button" class="close" 
                     v-on:click="modalShow = false">
                    <span >&times;</span>
                </button>
                <div class="modal-body">
                    <p class="modalSlider__title">{{product.name}}</p>
                    <slick 
                        class="slider-nav"
                        id='slick1'
                        ref="sliderNav"
                        :options="sliderNavSlickOptions">
                        <div v-for="(item, index) in product.photo" :key="index"><img :src="item" alt=""></div>
                    </slick>
                    <slick 
                        class="slider-for"
                        ref="sliderFor"
                        id="slick2"
                        :options="sliderForSlickOptions">
                        <div v-for="(item, index) in product.photo" :key="index"><img :src="item" alt=""></div>
                    </slick>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Slick from 'vue-slick';
export default {
    components: { Slick },
    props: [
        "product"
    ],
    data: () => ({
        modalShow: false,
        sliderForSlickOptions: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '#slick1' 
        },
        sliderNavSlickOptions: {
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '#slick2',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            vertical: true,
            appendArrows: "#slick1",
            prevArrow: "<span class='prevArr'></span>",
            nextArrow: "<span class='nextArr'></span>"
        }
    })
}
</script>